<template>
  <template v-if="status">
    <template v-if="renderText[status]">
      <a-tooltip
        v-if="renderText[status]?.hover"
        :title="renderText[status].hover"
        color="#ffffff"
        :overlayInnerStyle="{ color: '#121926' }"
      >
        <span
          :class="[
            renderText[status].color,
            'flex-y-center gap-[4px] justify-center',
          ]"
        >
          <svg
            viewBox="0 0 10 11"
            xmlns="http://www.w3.org/2000/svg"
            class="w-[14px] h-[14px]"
          >
            <g fill="none" fill-rule="evenodd">
              <path d="M0 .5h10v10H0z" />
              <g
                data-follow-stroke="#8580FF"
                data-follow-fill="#8580FF"
                fill="#8580FF"
                fill-rule="nonzero"
                stroke="#8580FF"
                stroke-width=".1"
              >
                <path
                  d="M2.364 7.69C1.094 7.69.06 6.705.06 5.49c0-1.213 1.033-2.2 2.304-2.2h1.002v.752H2.364c-.836 0-1.516.65-1.516 1.448 0 .799.68 1.448 1.516 1.448H5.01v.753H2.364Zm5.244-.746c.836 0 1.516-.65 1.516-1.449s-.68-1.448-1.516-1.448l-2.326-.005.002-.753 2.325.005c1.27 0 2.303.988 2.303 2.201 0 1.214-1.034 2.2-2.304 2.2v-.751Z"
                />
                <path
                  d="M5.011 5.876H3.445A.385.385 0 0 1 3.05 5.5c0-.208.176-.376.394-.376H5.01c.218 0 .394.168.394.376a.385.385 0 0 1-.394.376Z"
                />
                <path
                  d="M7.886 9.5a.4.4 0 0 1-.314-.149L1.823 2.103a.365.365 0 0 1 .076-.527.406.406 0 0 1 .552.073L8.2 8.897a.365.365 0 0 1-.076.527.405.405 0 0 1-.238.076Z"
                />
              </g>
            </g>
          </svg>
          {{ renderText[status].name }}
        </span>
      </a-tooltip>
      <span v-else :class="renderText[status].color">
        {{ renderText[status].name }}
      </span>
    </template>
    <span v-else></span>
  </template>
  <span v-else :class="waitClass">{{ $t('wei-xuan-ran') }}</span>
</template>

<script lang="ts" setup>
import { PROJECT_RENDER_STATUS } from '~/constants'
const props = defineProps<{ status: string }>()

const { status } = props
const { $t } = useNuxtApp()

const normalClass =
  'text-purple-5 p-[1px_6px] border-solid border-[1px] border-purple-3 rounded-[5px] text-[12px]'

const failClass =
  'text-font-50 p-[1px_6px] border-solid border-[1px] border-purple-3 rounded-[5px] text-[12px]'

const waitClass =
  'text-warning-6 p-[1px_6px] border-solid border-[1px] border-[#FFE3B9] rounded-[5px] text-[12px]'

const renderText: any = {
  [PROJECT_RENDER_STATUS.SEGMENT_COMPLETE]: {
    name: $t('xuan-ran-pian-duan'),
    color: normalClass,
  },
  [PROJECT_RENDER_STATUS.SEGMENT_INTERRUPT]: {
    name: $t('xuan-ran-pian-duan'),
    hover: $t('xuan-ran-zhong-duan-nin-ke-yu-lan-yi-xuan-ran-pian-duan'),
    icon: true,
    color: normalClass,
  },
  [PROJECT_RENDER_STATUS.INIT_INTERRUPT]: {
    name: $t('xuan-ran-wan-zheng'),
    hover: $t('xuan-ran-zhong-duan-nin-ke-yu-lan-yi-xuan-ran-pian-duan'),
    icon: true,
    color: normalClass,
  },
  [PROJECT_RENDER_STATUS.INIT_COMPLETE]: {
    name: $t('xuan-ran-wan-zheng'),
    color: normalClass,
  },
  [PROJECT_RENDER_STATUS.INIT_FAIL]: {
    name: $t('xuan-ran-shi-bai'),
    color: failClass,
  },
  [PROJECT_RENDER_STATUS.SEGMENT_ERROR]: {
    name: $t('xuan-ran-shi-bai'),
    color: failClass,
  },
}
</script>
